var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"mt-8 pa-0 justify-space-between",class:{ 'd-flex flex-column': _vm.reuseIsMobile }},[_c('v-flex',{staticClass:"label"},[_vm._v(" کد ملی ")]),_c('v-flex',{staticClass:"flex-column withlabel big"},[_c('NationalCode',{on:{"setValue":function($event){return _vm.$emit('set-national-code', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }